export enum PromiseSettledStatus {
    Fulfilled = 'fulfilled',
    Rejected = 'rejected'
}
